var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfficientlyOrganiseMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 68.1,
    width: 67.9,
    x: 2,
    y: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,18.2c-4.6,0-8.3-3.6-8.3-8.1S32.5,2,37.1,2s8.3,3.6,8.3,8.1S41.6,18.2,37.1,18.2z M37.1,4.8 c-2.9,0-5.3,2.3-5.3,5.2s2.4,5.2,5.3,5.2s5.3-2.3,5.3-5.2S40,4.8,37.1,4.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,30.5H23.8V28c0-7.2,6-13,13.3-13s13.3,5.8,13.3,13L50.3,30.5L50.3,30.5z M26.8,27.6h20.5V28 c0-5.6-4.6-10.1-10.3-10.1S26.8,22.5,26.8,28V27.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,53.5c-4.6,0-8.3-3.6-8.3-8s3.7-8,8.3-8s8.3,3.6,8.3,8S24.9,53.5,20.4,53.5z M20.4,40.4 c-2.9,0-5.3,2.3-5.3,5.1s2.4,5.1,5.3,5.1s5.3-2.3,5.3-5.1S23.3,40.4,20.4,40.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.6,70.1H7.1v-6.9c0-7.1,6-12.8,13.3-12.8S33.7,56,33.7,63.1L33.6,70.1L33.6,70.1z M10.1,67.1h20.5v-4 c0-5.5-4.6-9.9-10.3-9.9S10,57.6,10,63.1L10.1,67.1L10.1,67.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51,53c-4.6,0-8.3-3.6-8.3-8s3.7-8,8.3-8s8.3,3.6,8.3,8S55.5,53,51,53z M51,40c-2.9,0-5.3,2.3-5.3,5.1 s2.4,5.1,5.3,5.1s5.3-2.3,5.3-5.1C56.3,42.2,53.9,40,51,40z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.2,69.6H37.7v-6.9c0-7.1,6-12.8,13.3-12.8s13.3,5.7,13.3,12.8L64.2,69.6L64.2,69.6z M40.7,66.8h20.5 v-4c0-5.5-4.6-9.9-10.3-9.9s-10.3,4.4-10.3,9.9L40.7,66.8L40.7,66.8z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 43.4,
    y1: 54.2,
    x2: 27.3,
    y2: 54.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 52.7,
    className: "st0",
    width: 16.1,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.6,55.7h-5.3v-3h5.3c1.1,0,2-0.4,2.6-1.1c0.6-0.7,0.7-1.6,0.5-2.6l-3.3-15.4c-0.3-1.6-2.3-3-4.3-3H12.6 c-2,0-3.9,1.4-4.3,3L5.1,49c-0.2,1,0,1.9,0.5,2.6c0.6,0.7,1.5,1.1,2.6,1.1h5.2v3H8.2c-2,0-3.8-0.8-4.9-2.2s-1.5-3.2-1.1-5.1 L5.5,33c0.6-3,3.8-5.4,7.2-5.4h46.6c3.4,0,6.6,2.4,7.2,5.4l3.3,15.4c0.4,1.9,0,3.7-1.1,5.1C67.4,54.9,65.6,55.7,63.6,55.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,54.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficientlyOrganiseMeeting);
export default __webpack_public_path__ + "static/media/efficiently-organise-meeting.cf086dbcde56e4e5a0fc822f48c8c55d.svg";
export { ForwardRef as ReactComponent };